import React from 'react';
import LocalizedLink from 'helpers/LocalizeLink';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StrategyImage from '../../assets/img/strategy.png';
import { BuyBlock } from 'helpers/cart/BuyBlock';
import { Badge } from 'antd';
import { getLocalePrefix } from "helpers/util";

const MarketplaceItem = (props) => {
    const item = props.item;
    const index = props.index;
    const { t } = useTranslation();
    
    return (
        <div key={"mpi_" + index} className="marketplace-item d-flex flex-column justify-content-between py-4">
            <div className="mb-4">
                <p title={item.name} className="marketplace-title d-flex justify-content-center align-items-center mb-3">
                    <LocalizedLink to={getLocalePrefix() + '/strategy/' + item["id"]} dti={"mrkt-link-" + index} className="marketplace-title-link text-darkblue text-center text-bold px-3 ">{item['name']}</LocalizedLink>
                </p>
                <div className="marketplace-statistic d-flex justify-content-between align-items-center px-3 mb-3">
                    <span className="d-flex align-items-center text text-semibold">
                        <i className="mr-2"></i>{item['rating']}
                    </span>
                    <span className="text text-semibold">
                        {item['sales']} {props.item.price === "0.00" || item['price'] === "0.00" ? t('labels.added') : t('labels.sales')}
                    </span>
                </div>
                <LocalizedLink to={getLocalePrefix() + '/strategy/' + item["id"]} dti={"mrkt-img-" + index} className="marketplace-img mb-3">
                    <img src={StrategyImage} alt={item.name} title={item.name} className="w-100" />
                    <span><i></i></span>
                </LocalizedLink>
                <p className="marketplace-description text-justify text-small px-3" title={item.description}>{item.description}</p>
            </div>
            <BuyBlock item={item} checkout={false} viewOneStrategy={false} from="marketplace" dti={index} />
        </div>
    )
}

function MarketplaceItemWidget(props) {
    // Защита от null/undefined items
    if (!props.items || !Array.isArray(props.items) || props.items.length === 0) {
        return null;
    }

    return (
        <div className="marketplace container-xl row mx-auto p-0">
            {props.items.map((item, index) => {
                return (
                    <div key={index} className='col-lg-4 col-md-6 col-sm-12 mb-4' data-test-id={item?.price > 0 ? null : ("mrkt-ribbon-" + index)}>
                        {
                            item.price > 0?
                                <MarketplaceItem
                                    item={item}
                                    index = {index}
                                />
                                :
                                <Badge.Ribbon text="FOR FREE" color="orange" size="default">
                                    <MarketplaceItem
                                        item={item}
                                        index = {index}
                                    />
                                </Badge.Ribbon> 
                        }
                    </div>
                )
            })}
        </div>
    )
}

MarketplaceItemWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    price: PropTypes.string,
    stars: PropTypes.string,
    sales: PropTypes.string,
}

export default MarketplaceItemWidget;
